/**
 * Home scope for sessions that grant specific sellable apps (e.g. One Site).
 *
 * Workspace default is Medicine; Exam Management is licensed at Nursing only. Without
 * a stamp, owned Exam shows as Other program with Try the beta instead of Open.
 */

import {
  readSchoolFamilyScope,
  stampSchoolFamilyScope,
} from "@/hooks/use-active-scope"
import { grantedProducts } from "@/lib/login-session"
import {
  productLicensesScope,
  scopeConfigForProduct,
} from "@/lib/scope-switcher"

/** Move school/program scope to the first campus that licenses every granted app. */
export function ensureGrantedProductsHomeScope(): void {
  const products = grantedProducts()
  if (!products || products.length === 0) return

  const config = scopeConfigForProduct("exxat-prism")
  const parent = config.defaultParent
  const stored = readSchoolFamilyScope()
  const parentId = stored?.parentId ?? parent.id
  const childId = stored?.childId

  if (
    childId &&
    products.every(product => productLicensesScope(product, parentId, childId))
  ) {
    return
  }

  for (const child of config.childrenOf(parent)) {
    if (products.every(product => productLicensesScope(product, parent.id, child.id))) {
      if (stored?.parentId === parent.id && stored.childId === child.id) return
      stampSchoolFamilyScope(parent, child)
      return
    }
  }
}
